import { render, staticRenderFns } from "./Talentinfo.vue?vue&type=template&id=a0ac6a06&scoped=true&"
import script from "./Talentinfo.vue?vue&type=script&lang=js&"
export * from "./Talentinfo.vue?vue&type=script&lang=js&"
import style0 from "./Talentinfo.vue?vue&type=style&index=0&id=a0ac6a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ac6a06",
  null
  
)

component.options.__file = "Talentinfo.vue"
export default component.exports